module.exports = __webpack_public_path__ + "static/media/urban-work.bc2599fe.png";